import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["weekSelect", "citySelect"]
  static values = { weekCityMap: Object }

  connect() {
    this.syncCity()
  }

  syncCity() {
    if (!this.hasWeekSelectTarget || !this.hasCitySelectTarget) return

    const weekId = this.weekSelectTarget.value
    const cityId = this.weekCityMapValue[weekId]

    if (weekId && cityId) {
      this.citySelectTarget.value = cityId.toString()
      this.citySelectTarget.disabled = true
      return
    }

    this.citySelectTarget.disabled = false
  }
}
